import type { ValidationIssue } from "@nexxt/contracts";

/**
 * The words for the issues of a domain (422 `details.issues`), from the complete `Record` of its rules: a rule nobody
 * gave a text to is shown as it is.
 */
export function issueTexts<R extends string>(rules: Record<R, () => string>) {
  const ruleText = (rule: string): string => (Object.hasOwn(rules, rule) ? rules[rule as R]() : rule);
  return {
    ruleText,
    /** The issue of a field, or of the first of the fields named, for the form that shows it next to the control. */
    fieldIssue(issues: ValidationIssue[], ...fields: string[]): string | undefined {
      const found = issues.find((issue) => fields.includes(issue.field));
      return found && ruleText(found.rule);
    },
    /** Every issue of a field at once, for a refusal that lists all the rules broken (a new password, ADR-147). */
    fieldIssues(issues: ValidationIssue[], field: string): string | undefined {
      const texts = issues.filter((issue) => issue.field === field).map((issue) => ruleText(issue.rule));
      return texts.length ? texts.join(" ") : undefined;
    },
  };
}
